export const getGoogleReportRequestError = async responses => {
    const failed = responses.find(response => !response.ok);
    if (!failed) return null;
    const payload = await failed.json().catch(() => ({}));
    const code = payload?.error?.code || payload.reason || '';
    let message;
    if (code === 'report_password_required') message = 'Your report access needs to be unlocked again.';
    else if (payload.reconnect) message = 'Google Ads needs to be reconnected by your account team. Its saved authorization was rejected by Google.';
    else if (failed.status === 503 && payload.service === 'ads') message = 'Google Ads access could not be refreshed right now. Try again shortly.';
    else message = typeof payload.error === 'string' ? payload.error : payload.error?.message || 'Google Ads performance could not be loaded. Check the connection or report filters, then try again.';
    return Object.assign(new Error(message), { reportMessage: message, reconnect: Boolean(payload.reconnect), code });
};
